import { useApp } from "../context";
import { Heading, Table, CaseLink, Filters, Badge } from "../components/Bits";
import { money, advance, entitlement, getPartner, pending, paid, checks, visibleCases } from "../lib/engine";

const PayoutRow = ({ c }) => {
  const { state, actor, actions } = useApp();
  const instruction = pending(state, c);
  const failures = checks(state, c, !!instruction).filter(item => !item[1]);
  const isPaid = paid(state, c) > 0;
  return (
    <tr data-testid={`payout-row-${c.id}`}>
      <td><CaseLink c={c} /><small>{getPartner(state, c).name}</small></td>
      <td className="number">{money(advance(c))}<small>80% of {money(entitlement(c))}</small></td>
      <td>
        <Badge testId={`payout-control-${c.id}`}
          text={isPaid ? "Duplicate blocked" : failures.length ? "Blocked" : "Checks passed"} />
        <small>{isPaid ? "Advance already paid" : failures.map(item => item[0]).join("; ") || "Eligible"}</small>
      </td>
      <td><Badge testId={`payout-status-${c.id}`}
        text={isPaid ? "Paid (simulated)" : instruction ? "Approval pending" : "Not requested"} /></td>
      <td><div className="actions">
        {instruction ? (
          <>
            <button data-testid={`approve-btn-${c.id}`} disabled={actor !== "checker"}
              onClick={() => actions.approveAdvance(c.id)}>Approve simulation</button>
            <button data-testid={`reject-btn-${c.id}`} disabled={actor !== "checker"}
              onClick={() => actions.approveAdvance(c.id, true)}>Reject</button>
          </>
        ) : (
          <button data-testid={`request-btn-${c.id}`} disabled={actor !== "maker"}
            onClick={() => actions.requestAdvance(c.id)}>
            {isPaid ? "Test duplicate block" : "Request advance"}
          </button>
        )}
      </div></td>
    </tr>
  );
};

export default function Payouts() {
  const { state, search, region } = useApp();
  return (
    <>
      <Heading title="Payout approvals" description="Eligibility checks run before request and again before approval." />
      <div className="notice" data-testid="payout-simulation-notice">
        Operations maker accounts request advances; a different Finance checker account approves them.
        Your signed-in role decides which buttons you can use. Approvals are simulated: no real money moves.
      </div>
      <div className="card">
        <Filters />
        <Table testId="payouts-table" headers={["Case / DSA", "Proposed advance", "Control result", "Status", "Action"]}>
          {visibleCases(state, search, region).map(c => <PayoutRow key={c.id} c={c} />)}
        </Table>
      </div>
    </>
  );
}
